import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

type HelpType = "info" | "warn" | "alert" | "question";

@Component({
  selector: "help-icon",
  template: `
    <i
      style="font-size: 17px; margin-left: 5px;"
      [class]="this.details.icon"
      [ngClass]="[icons[type].color, sizeMap[size]]"
      [ngbTooltip]="this.content"
    ></i>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpIconComponent {
  @Input() type: HelpType;
  @Input() content: string;
  @Input() size: "sm" | "md" | "lg" = "md";

  icons: { [key in HelpType]: { icon: string; color: string } } = {
    info: { icon: "feather icon-info", color: "text-primary" },
    warn: { icon: "feather icon-alert-circle", color: "text-warning" },
    alert: { icon: "feather icon-alert-octagon", color: "text-danger" },
    question: { icon: "feather icon-help-circle", color: "text-info" },
  };

  sizeMap = {
    sm: "fa-sm",
    md: "",
    lg: "fa-2x",
  };

  get details() {
    return this.icons[this.type];
  }
}
